import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../_services/storage.service';
import { HackyService } from '../../_services/hacky.service';
import { ApiService } from '../../_services/api.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styles: []
})
export class FooterComponent implements OnInit {

  constructor(
    private storage: StorageService,
    private hacky: HackyService,
    private api: ApiService
    ) {
      this.isMobile = window.innerWidth < environment.mobileBreakpoint;
     }

  footer: any[] = [];
  privacy: any[] = [];
  lingue: any[] = [];
  isServer = false;
  isMobile = false;

  newsletterHidden = false;
  modalShow = false

  email = '';
  checkPrivacy = false;

  ngOnInit() {
    this.hacky.hideNewsletter.subscribe((hidden) => this.newsletterHidden = hidden);
    this.storage.getMapponeInLingua().subscribe(mappone => {
      this.footer = mappone.menuFooter;
      this.privacy = mappone.menuPrivacy;
      this.lingue = mappone.lingue;
    });
    this.isServer = !this.storage.isBrowser;
  }

  newsletter() {
    this.api.newsletter({email: this.email}).subscribe((res: any) => {
      if (res.esito === 'OK') {
        this.modalShow = true;
      }
    });
  }

  openFacebook() {
    
    const userAgent = navigator.userAgent || navigator.vendor;

    if (this.isMobile && /iPad|iPhone|iPod/.test(userAgent)) {
      setTimeout(() => {
        window.location.href = 'https://www.facebook.com/stemtechnology';
      }, 25);
      window.location.href = 'fb://profile/?id=stemtechnology';
    } else {
      window.open(
        'https://www.facebook.com/stemtechnology',
        '_blank',
      );
    }
  }
}
